export default "__VITE_ASSET__5uvo0nUl__"